// extracted by mini-css-extract-plugin
export var active = "_5d-a";
export var activeIndicator = "_5d-9";
export var disabled = "_5d-b";
export var fullWidth = "_5d-2";
export var lg = "_5d-7";
export var md = "_5d-6";
export var redoButtonTabGroup = "_5d-0";
export var sm = "_5d-5";
export var tabButton = "_5d-4";
export var tabButtonsContainer = "_5d-1";
export var themeDestructive = "_5d-d";
export var themeNormal = "_5d-c";
export var themeSuccess = "_5d-e";
export var xl = "_5d-8";
export var xs = "_5d-3";